module.exports = __webpack_public_path__ + "img/Logstash.bb4cad90.png";